"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _RegionStorePane = _interopRequireDefault(require("../RegionStorePane.vue"));
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _group_buy = require("@/api/goods_activity/group_buy");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GroupBuyConfigPane',
  components: {
    RegionStorePane: _RegionStorePane.default
  },
  props: {
    groupBuyFnId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      form: {
        activityName: '',
        // 活动名称
        menuTypes: [],
        // 点餐类型
        executeDateList: [],
        // 执行日期
        executeTimeList: ['09:00', '23:00'],
        // 执行时间
        markForEnable: true,
        // 是否启用
        storeScope: 0,
        // 店铺范围
        markAllGoods: false,
        // 是否选择全部商品
        thresholdType: 'quantity',
        // 满件数类型
        thresholdQuantity: 0,
        // 满件数
        thresholdUser: 0,
        // 满用户数
        thresholdAmount: 0,
        // 满金额
        discount: 0,
        // 优惠金额
        activityDescribe: '',
        // 活动描述
        checkedGoodsList: [],
        // 选中商品列表用于展示列表
        relatedStoreIdList: [] // 指定门店ID
      },
      validDate: false,
      // 有效日期
      menuTypeList: [],
      // 点餐类型列表
      thresholdTypeList: [],
      // 满件数类型列表
      regionStoreList: [],
      // 指定区域门店
      goodsTableKey: 0,
      // 商品表格的key
      searchGoodsLoading: false,
      goodsList: [],
      // 推荐商品列表
      checkedGoods: {} // 选中商品
    };
  },
  created: function created() {
    this.getMenuType();
    this.queryThresholdType();
    this.queryRegionStoreList();
    if (this.groupBuyFnId) {
      this.getGroupBuyDetail();
    }
  },
  methods: {
    changeValidDate: function changeValidDate() {
      var _this = this;
      this.loading = true;
      this.validDate = false;
      var validForm = {
        fnId: this.groupBuyFnId,
        executeDateList: this.form.executeDateList,
        executeTimeList: this.form.executeTimeList
      };
      (0, _group_buy.checkValidDate)(validForm).then(function (res) {
        var data = res.data;
        if (data) {
          _this.validDate = true;
          _this.$message.error('日期冲突');
        } else {
          _this.validDate = false;
        }
        _this.loading = false;
      }, function () {
        _this.loading = false;
      });
    },
    getGroupBuyDetail: function getGroupBuyDetail() {
      var _this2 = this;
      (0, _group_buy.queryGroupBuyDetail)(this.groupBuyFnId).then(function (res) {
        var data = res.data;
        if (data) {
          _this2.form.activityName = data.gaGroupBuy.activityName;
          _this2.form.menuTypes = data.menuTypes || [];
          _this2.form.markAllGoods = data.markAllGoods;
          _this2.form.executeDateList = data.executeDateList || [];
          _this2.form.executeTimeList = data.executeTimeList || [];
          _this2.form.markForEnable = data.gaGroupBuy.markForEnable;
          _this2.form.storeScope = data.gaGroupBuy.storeScope;
          _this2.form.thresholdType = data.gaGroupBuy.thresholdType;
          _this2.form.thresholdQuantity = data.thresholdQuantity;
          _this2.form.thresholdUser = data.thresholdUser;
          _this2.form.thresholdAmount = data.thresholdAmount;
          _this2.form.discount = data.gaGroupBuy.discount;
          _this2.form.activityDescribe = data.gaGroupBuy.activityDescribe;
          _this2.form.relatedStoreIdList = data.relatedStoreIdList || [];
          _this2.form.checkedGoodsList = data.checkedGoodsList || [];
        }
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;
      this.loading = true;
      if (this.groupBuyFnId) {
        // 编辑
        var editData = _objectSpread(_objectSpread({}, this.form), {}, {
          fnId: this.groupBuyFnId
        });
        (0, _group_buy.updateGroupBuy)(editData).then(function (res) {
          _this3.loading = false;
          _this3.$message.success(res.message);
          _this3.$emit('success');
        }, function () {
          _this3.loading = false;
        });
      } else {
        // 新建
        (0, _group_buy.addGroupBuy)(this.form).then(function (res) {
          _this3.loading = false;
          _this3.$message.success(res.message);
          _this3.$emit('success');
        }, function () {
          _this3.loading = false;
        });
      }
    },
    handleRegionStoreChange: function handleRegionStoreChange(val) {
      // 判断 val 数组中的值是否存在 this.form.relatedStoreIdList 中，存在不处理，不存在添加
      for (var i = 0; i < val.length; i++) {
        var storeId = val[i];
        if (!this.form.relatedStoreIdList.includes(storeId)) {
          this.form.relatedStoreIdList.push(storeId);
        }
      }
    },
    addGoods: function addGoods() {
      var exist = false;
      if (this.checkedGoods && this.checkedGoods.goodsFnId) {
        for (var i = 0; i < this.form.checkedGoodsList.length; i++) {
          var goods = this.form.checkedGoodsList[i];
          if (this.checkedGoods.goodsFnId === goods.goodsFnId) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          this.form.checkedGoodsList.push(this.checkedGoods);
        }
        this.checkedGoods = {};
      }
    },
    removeGoods: function removeGoods(row) {
      var index = -1;
      for (var i = 0; i < this.form.checkedGoodsList.length; i++) {
        var goods = this.form.checkedGoodsList[i];
        if (row.goodsFnId === goods.goodsFnId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.form.checkedGoodsList.splice(index, 1);
      }
    },
    searchGoods: function searchGoods(query) {
      var _this4 = this;
      this.searchGoodsLoading = true;
      (0, _goods_activity_combo.queryGoodsSearch)({
        keywords: query
      }).then(function (res) {
        var data = res.data;
        if (data) {
          _this4.goodsList = data.goodsList || [];
          _this4.searchGoodsLoading = false;
        }
      }, function () {
        _this4.searchGoodsLoading = false;
      });
    },
    getMenuType: function getMenuType() {
      var _this5 = this;
      (0, _goods_activity_combo.queryMenuTypeByGroupBuy)().then(function (res) {
        var data = res.data;
        if (data) {
          _this5.menuTypeList = data.records || [];
        }
      });
    },
    queryThresholdType: function queryThresholdType() {
      var _this6 = this;
      (0, _goods_activity_combo.queryThresholdType)().then(function (res) {
        var data = res.data;
        if (data) {
          _this6.thresholdTypeList = data.records || [];
        }
      });
    },
    queryRegionStoreList: function queryRegionStoreList() {
      var _this7 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data) {
          _this7.regionStoreList = data.storeRegions || [];
        }
      });
    }
  }
};